import util from '../../lib/util';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from "../find";
import InvoiceBatchItem from '../../entities/invoiceBatchItem';
import InvoiceBatch from '../../entities/invoiceBatch';

/*
 * Delete/nullify anywhere this invoiceBatchItem is used in other entities
 *
 * @param {InvoiceBatchItem} invoiceBatchItem
 */
export function deleteInvoiceBatchItem(invoiceBatchItem: InvoiceBatchItem, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = invoiceBatchItem.id;
    }
    /* Simple delete usages */
        
    store.getState().invoiceBatches
        .getMappingFor('invoiceBatchItemId', invoiceBatchItem.id)
        .filter(invoiceBatchTemp => invoiceBatchTemp.status !== 'D')
        .forEach(invoiceBatchTemp => {
            const _invoiceBatch = invoiceBatchTemp.clone();
            _invoiceBatch.status =  'U';
            _invoiceBatch.addedOn = newHRTimestamp();
            _invoiceBatch.importSource = targetImportSource;
            _invoiceBatch.importId = mergeId;

            _invoiceBatch.invoiceBatchItemIds = _invoiceBatch.invoiceBatchItemIds?.filter(id => id !== invoiceBatchItem.id) || [];
            store.dispatch(Actions.InvoiceBatchActions.saveInvoiceBatchQueue(_invoiceBatch));
        });

    /* Remove the actual invoiceBatchItem */
    invoiceBatchItem.status = 'D';
    invoiceBatchItem.addedOn = newHRTimestamp();
    invoiceBatchItem.addedBy = getCurrentUserId();
    invoiceBatchItem.importSource = targetImportSource;
    invoiceBatchItem.importId = mergeId;
    store.dispatch(Actions.InvoiceBatchItemActions.removeInvoiceBatchItemQueue(invoiceBatchItem));
    
}

/*
 * Replace anywhere this invoiceBatchItem is used in other entities.
 *
 * @param {InvoiceBatchItem} invoiceBatchItem
 * @param {InvoiceBatchItem} replaceWith
 * @return {InvoiceBatchItem} - InvoiceBatchItem will have refs stripped away
 */
export function replaceInvoiceBatchItem(invoiceBatchItem: InvoiceBatchItem, replaceWith: InvoiceBatchItem, mergeId?: string) {
    let targetImportSource = 'merge';

    if (!mergeId) {
        targetImportSource = 'delete';
        mergeId = invoiceBatchItem.id;
    }
    /* Simple replace usages */
        
    store.getState().invoiceBatches
        .getMappingFor('invoiceBatchItemId', invoiceBatchItem.id)
        .filter(invoiceBatchTemp => invoiceBatchTemp.status !== 'D')
        .forEach(invoiceBatchTemp => {
            const _invoiceBatch = invoiceBatchTemp.clone();
            _invoiceBatch.status =  'U';
            _invoiceBatch.addedOn = newHRTimestamp();
            _invoiceBatch.importSource = targetImportSource;
            _invoiceBatch.importId = mergeId;

            _invoiceBatch.invoiceBatchItemIds = _invoiceBatch.invoiceBatchItemIds?.map(id => (id === invoiceBatchItem.id) ? replaceWith.id : id) || [];
            store.dispatch(Actions.InvoiceBatchActions.saveInvoiceBatchQueue(_invoiceBatch));
        });

    return invoiceBatchItem;
}

/*
 * Determine the impact of deleting this invoiceBatchItem from other entities
 *
 * @param {InvoiceBatchItem} invoiceBatchItem
 * @return {Array.<{count: number, entity: string}>} - a list of impacted entities, along with a count of impacted entities
 */
export function deleteImpactInvoiceBatchItem(invoiceBatchItem: InvoiceBatchItem) {
    const impacts: string[] = [];
    const state = store.getState();
    
    /* Simple delete usages */
        
    const invoiceBatchInvoiceBatchItemIdsImpact = state.invoiceBatches
          .getMappingFor('invoiceBatchItemId', invoiceBatchItem.id)
          .filter(invoiceBatch => invoiceBatch.status !== 'D');

    invoiceBatchInvoiceBatchItemIdsImpact.forEach(() => impacts.push('invoiceBatches'));

    return util.countDistinct(impacts);
}